const INCH_IN_MILLIMETER_FAKTOR = 25.4;
const INCH_SQUARED_IN_QUADRATMILLIMETER_FAKTOR = 645.16;
const FOOT_FAKTOR = 0.3048;
const KILOPOUND_PER_SQUARE_INCH_IN_MEGAPSCAL_FAKTOR = 6.89475908677537;
const KILOPOUND_IN_KILONEWTON_FAKTOR = 4.4482216;
const KILOPOUND_PER_SQUARE_FOOT_IN_KILONEWTON_PRO_QUADRATMETER_FAKTOR = 47.880258888889;
const KSF_TO_PSI_FACTOR = 0.144000092;

function werteValidierung(wert) {
  if (wert < 0) {
    return false;
  }

  return true;
}

export const inchInMillimeter = (imperialWert) => {
  if (!werteValidierung(imperialWert)) {
    return 0;
  }

  return Number(imperialWert) * INCH_IN_MILLIMETER_FAKTOR;
};
export const millimeterInInch = (metrischerwert) => {
  if (!werteValidierung(metrischerwert)) {
    return 0;
  }

  return Number(metrischerwert) / INCH_IN_MILLIMETER_FAKTOR;
};

export const inchSquaredInQuadratmillimeter = (imperialWert) => {
  if (!werteValidierung(imperialWert)) {
    return 0;
  }

  return Number(imperialWert) * INCH_SQUARED_IN_QUADRATMILLIMETER_FAKTOR;
};
export const quadratmillimeterInInchSquared = (metrischerwert) => {
  if (!werteValidierung(metrischerwert)) {
    return 0;
  }

  return Number(metrischerwert) / INCH_SQUARED_IN_QUADRATMILLIMETER_FAKTOR;
};

export const footInMeter = (imperialWert) => {
  if (!werteValidierung(imperialWert)) {
    return 0;
  }

  return Number(imperialWert) * FOOT_FAKTOR;
};
export const meterInFoot = (metrischerwert) => {
  if (!werteValidierung(metrischerwert)) {
    return 0;
  }

  return Number(metrischerwert) / FOOT_FAKTOR;
};

export const kilopoundPerSquareInchInMegapscal = (imperialWert) => {
  if (!werteValidierung(imperialWert)) {
    return 0;
  }

  return Number(imperialWert) * KILOPOUND_PER_SQUARE_INCH_IN_MEGAPSCAL_FAKTOR;
};
export const megapscalInKilopoundPerSquareInch = (metrischerwert) => {
  if (!werteValidierung(metrischerwert)) {
    return 0;
  }

  return Number(metrischerwert) / KILOPOUND_PER_SQUARE_INCH_IN_MEGAPSCAL_FAKTOR;
};

export const kilopoundInKilonewton = (imperialWert) => {
  if (!werteValidierung(imperialWert)) {
    return 0;
  }

  return Number(imperialWert) * KILOPOUND_IN_KILONEWTON_FAKTOR;
};
export const kilonewtonInKilopound = (metrischerwert) => {
  if (!werteValidierung(metrischerwert)) {
    return 0;
  }

  return Number(metrischerwert) / KILOPOUND_IN_KILONEWTON_FAKTOR;
};

export const kilopoundPerSquareFootInKilonewtonProQuadratmeter = (imperialWert) => {
  if (!werteValidierung(imperialWert)) {
    return 0;
  }

  return Number(imperialWert) * KILOPOUND_PER_SQUARE_FOOT_IN_KILONEWTON_PRO_QUADRATMETER_FAKTOR;
};

export const kilonewtonProQuadratmeterInKilopoundPerSquareFoot = (metrischerwert) => {
  if (!werteValidierung(metrischerwert)) {
    return 0;
  }

  return Number(metrischerwert) / KILOPOUND_PER_SQUARE_FOOT_IN_KILONEWTON_PRO_QUADRATMETER_FAKTOR;
};

export const poundPerSquaredInchInKiloNewtonDividedByMetreSquared = (imperialWert) => {
  if (!werteValidierung(imperialWert)) {
    return 0;
  }

  return Number(imperialWert) * KILOPOUND_PER_SQUARE_INCH_IN_MEGAPSCAL_FAKTOR;
};
export const kiloNewtonDividedByMetreSquaredInPoundPerSquaredInchIn = (metrischerwert) => {
  if (!werteValidierung(metrischerwert)) {
    return 0;
  }

  return Number(metrischerwert) / KILOPOUND_PER_SQUARE_INCH_IN_MEGAPSCAL_FAKTOR;
};

export const INFtoMaxInt = (value = "inf") => {
  let str = value.toLowerCase();
  if (str == "inf") {
    return Number.MAX_SAFE_INTEGER;
  }

  return value;
};

export const MaxIntToINF = (value, precision) => {
  if (Number(value) == Number.MAX_SAFE_INTEGER || Number(value) > 900_000_000) {
    return "INF";
  }

  if (precision != null || precision != undefined) {
    return Number(Number(value).toFixed(Number(precision)));
  }
  if (isNaN(value)) return "";
  return value;
};
